import React, { useState } from "react";
import PropTypes from "prop-types";
import { Box, Tooltip } from "@mui/material";
import MessageItem from "../Chat/MessagesArea/ChatWindow/MessageItem";
import makeStyles from '@mui/styles/makeStyles';

const ChatVideo = ({ src, user, message, key, platform, queuesName, activeChat }) => {

    const [error, setError] = useState(false)

    const useStyles = makeStyles((theme) => {
        return {
            video: {
                maxWidth: '250px',
                border: user !== 0 ? '3px solid #21446C' : '3px solid #f1f0f7',
                borderRadius: '5px',
                marginTop: '5px',
                marginBottom: '5px'
            }
        }
    })

    const classes = useStyles();

    return (
        <>
            {!error ?
                <Box display="flex"
                    justifyContent={user !== 0 ? 'flex-end' : 'flex-start'}
                    className={classes.root}
                >
                    <Tooltip placement='left' title={message?.agent_name ? `Enviado por: ${message?.agent_name}` : ''}>
                        <video className={classes.video} controls
                            type="video/mp4"
                            src={src}
                            onError={() => { setError(true) }}
                        />
                    </Tooltip>
                </Box>
                :
                <MessageItem
                    key={key}
                    message={{ ...message, message: 'Esse vídeo não está mais disponível' }}
                    user={user}
                    queuesName={queuesName}
                    platform={platform}
                    media={true}
                    activeChat={activeChat}
                />
            }
        </>
    )
}


ChatVideo.PropTypes = {
    src: PropTypes.any,
    user: PropTypes.string
};

export default ChatVideo;
